"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConditionFields = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../../fields");

var _conditionConfig = require("./conditionConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ConditionDefinition = _flowRuntime["default"].tdz(function () {
  return _conditionConfig.ConditionDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("condition", _flowRuntime["default"].ref(ConditionDefinition)), _flowRuntime["default"].property("diagnosed", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].array(_flowRuntime["default"].string())), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var ConditionFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ConditionFields, _React$Component);

  var _super = (0, _createSuper2["default"])(ConditionFields);

  function ConditionFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, ConditionFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function () {
      var _this$props = _this.props,
          diagnosed = _this$props.diagnosed,
          resetFields = _this$props.resetFields,
          componentKey = _this$props.componentKey;
      var fields = ["".concat(componentKey, ".ongoing"), "".concat(componentKey, ".details"), "".concat(componentKey, ".yearDiagnosed"), "".concat(componentKey, ".diagnosed")];

      if (diagnosed) {
        resetFields(componentKey, fields);
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(ConditionFields, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          condition = _this$props2.condition,
          componentKey = _this$props2.componentKey,
          diagnosed = _this$props2.diagnosed;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: componentKey
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "medical-condition group"
      }, /*#__PURE__*/_react["default"].createElement(_fields.Checkbox, {
        id: (0, _conditionConfig.diagnosedCheckbox)(condition).key,
        type: "checkbox",
        onChange: this.onChange,
        checked: diagnosed,
        checkbox: (0, _conditionConfig.diagnosedCheckbox)(condition),
        noOptionalLabel: true
      }), diagnosed && /*#__PURE__*/_react["default"].createElement("div", {
        className: "condition-questions"
      }, /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        id: _conditionConfig.yearDiagnosedSelect.key,
        key: _conditionConfig.yearDiagnosedSelect.key,
        select: _conditionConfig.yearDiagnosedSelect,
        noOptionalLabel: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col span_7_of_12"
      }, /*#__PURE__*/_react["default"].createElement(_fields.Radio, {
        id: _conditionConfig.ongoingRadio.key,
        key: _conditionConfig.ongoingRadio.key,
        radio: _conditionConfig.ongoingRadio,
        noOptionalLabel: true
      })), /*#__PURE__*/_react["default"].createElement(_fields.Textarea, {
        id: _conditionConfig.detailsTextarea.key,
        key: _conditionConfig.detailsTextarea.key,
        textarea: _conditionConfig.detailsTextarea,
        noOptionalLabel: true
      }))));
    }
  }]);
  return ConditionFields;
}(_react["default"].Component);

exports.ConditionFields = ConditionFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    diagnosed: selector(state, "".concat(componentKey, ".diagnosed"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetFields: function resetFields(componentKey, fields) {
      Promise.all([dispatch((0, _reduxForm.change)('form', componentKey, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat((0, _toConsumableArray2["default"])(fields))))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConditionFields);

exports["default"] = _default;